import { Box } from '@material-ui/core';
import { CheckoutSessionStatus } from '@nemuru-eng/js-api-client';

import { SummaryLine } from '@/components/modules/_shared/components/SummaryLine';
import { ApplicationStatusChip } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/ApplicationStatusChip';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface OrderSummaryProps {
  titleTextId?: string;
  checkoutSessionStatus?: CheckoutSessionStatus;
  orderReference1: string;
  orderReference2?: string;
}

export const OrderSummary = ({
  titleTextId = 'ORDER_DATA',
  checkoutSessionStatus,
  orderReference1,
  orderReference2,
}: OrderSummaryProps) => {
  return (
    <>
      <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'}>
        <Font variant="h5" color="title">
          <Text strong tId={titleTextId} />
        </Font>
        {checkoutSessionStatus && (
          <Box position="relative" top="-4px">
            <ApplicationStatusChip checkoutSessionStatus={checkoutSessionStatus} />
          </Box>
        )}
      </Box>
      <Box display={'flex'} flexDirection={'column'} gridGap={8} pt={1}>
        <SummaryLine label="ORDER_REFERENCE" value={orderReference1} />
        <SummaryLine label="MERCHANT_ORDER_REFERENCE_2" value={orderReference2} />
      </Box>
    </>
  );
};
